import { PayoutDestinationType } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { WSQueries } from "../../../query/WSQuery";
import { queriesExternalBankAccounts, queriesPayouts } from "@query";
import { useQueryOwnPayoutSettings } from "@hooks/useQueryOwnPayoutSettings";
import { useExternalBankAccountsPlaidLink } from "../../hooks/useExternalBankAccountsPlaidLink";
import { Form } from "./Form";

type Props = {
  onSuccess?: () => void;
};

export const FormContainer: React.FC<Props> = ({ onSuccess }) => {
  const queryExternalBankAccounts =
    queriesExternalBankAccounts.listExternalBankAccounts.useQuery(undefined, {
      refetchOnMount: true
    });
  const queryPayoutSettings = useQueryOwnPayoutSettings();

  const plaidLink = useExternalBankAccountsPlaidLink({
    onSuccess: () => {}
  });

  const [updatePayoutSettings, submitMeta] =
    queriesPayouts.updatePayoutSettings.useMutation({
      dependencies: [
        queriesExternalBankAccounts.listExternalBankAccounts.queryKeyBase
      ],
      onSuccess
    });

  const submit = ({ accountId }: { accountId?: string }) => {
    if (!accountId) {
      throw new Error("Please, choose one account");
    }
    const payoutSettingsId = queryPayoutSettings.data?.id;
    if (!payoutSettingsId) {
      return;
    }
    return updatePayoutSettings({
      payoutSettingsId,
      payoutSettingsUpdate: {
        standardDestination: {
          type: PayoutDestinationType.EXTERNAL_BANK_ACCOUNT,
          id: accountId
        }
      }
    });
  };

  return (
    <WSQueries queries={{ queryExternalBankAccounts, queryPayoutSettings }}>
      {({
        queryExternalBankAccounts: { data: externalBankAccountList },
        queryPayoutSettings: { data: payoutSettings }
      }) => (
        <Form
          externalBankAccounts={externalBankAccountList.data || []}
          payoutSettings={payoutSettings}
          onSubmit={accountId => submit({ accountId })}
          onLinkAnotherAccount={plaidLink.open}
          error={submitMeta.error}
          isLoading={submitMeta.isLoading}
        />
      )}
    </WSQueries>
  );
};
